import type { SearchBlockProps } from '../types';
import { theme, sectionColors, cssColor, buttonVars } from '../theme';

/**
 * Property-search bar (Buy/Rent toggle + input + button). Server-safe: the input
 * is a plain GET form to the tenant's /listings results page (no client JS). The
 * Buy/Rent toggle is presentational for now (status filtering is a follow-up).
 */
export function SearchBlock(props: SearchBlockProps) {
  const { heading, placeholder = 'City, neighborhood, or ZIP…', showBuyRent = true } = props;
  const colors = { ...sectionColors(props, { bg: theme.surface, text: theme.text }), ...buttonVars(props) };
  return (
    <section className="px-6 py-10" style={{ ...colors, fontFamily: theme.bodyFont }}>
      <div className="mx-auto max-w-2xl text-center">
        {heading ? <h2 className="mb-4 text-2xl font-semibold" style={{ fontFamily: theme.headingFont }}>{heading}</h2> : null}
        {showBuyRent ? (
          <div className="mb-4 inline-flex overflow-hidden rounded-md border border-black/10">
            <span className="px-5 py-2 text-sm font-medium text-white" style={{ backgroundColor: theme.primary }}>Buy</span>
            <span className="px-5 py-2 text-sm font-medium">Rent</span>
          </div>
        ) : null}
        {/* name="address" → the gateway matches it with contains(UnparsedAddress),
            which spans street + city + state + zip, so one box searches all of them.
            (name="city" did an exact City match, so a ZIP/street returned nothing.) */}
        <form
          action="/listings"
          method="get"
          className="flex overflow-hidden rounded-md border border-black/10 shadow-sm"
          style={{ backgroundColor: cssColor(props.searchBgColor) ?? theme.background }}
        >
          <input type="text" name="address" placeholder={placeholder} className="w-full px-4 py-3 outline-none bg-transparent" style={{ color: cssColor(props.searchTextColor) ?? theme.text }} />
          <button type="submit" className="blk-btn shrink-0 px-6 py-3 font-medium">Search</button>
        </form>
      </div>
    </section>
  );
}
